module.exports = __webpack_public_path__ + "static/media/Maf_13Webinars.db59b7af.jpg";